import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ObserverEmitter, { EVENTS } from "../../emitter/Observer";
import { DialogBarNew } from "../../components/common/DialogBarNew";
import { ButtonPlay } from "../../components/common/ButtonPlay";
import { ButtonHome } from "../../components/common/ButtonHome";
import { SelectorCharacterUI } from "../introduction/SelectorCharacterUI";
import { audiosAssets } from "../../assets/audio";
import { voicesTypeControl } from "../../types/audioType";

const steps = {
	selectCharacter: 1,
	dialogInitial: 2,
	dialogTwo: 3,
};

export const IntroductionTeam2 = () => {
	const { loaded } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(steps.selectCharacter);

	useEffect(() => {
		if (loaded) {
			ObserverEmitter.emit(EVENTS.team2.introduction, 0);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
	})

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
			</>
			{uiToShow === steps.selectCharacter && (
				<SelectorCharacterUI
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.introduccion.intro01T2)
						setUiToShow(steps.dialogInitial);
						ObserverEmitter.emit(EVENTS.move_escritorio_introduction);
					}}
				></SelectorCharacterUI>
			)}
			{uiToShow === steps.dialogInitial && (
				<DialogBarNew
					dialog={
						"Te doy la bienvenida a la Tienda Receso, el trapo azul que obtuviste en la Tienda Hogar te será de gran utilidad en esta zona."
					}
					percentage={"50%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.introduccion.intro02T2)
						ObserverEmitter.emit(EVENTS.characterAnimations.idle);
						setUiToShow(steps.dialogTwo);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogTwo && (
				<DialogBarNew
					dialog={
						"Durante esta sección, exploraremos la Operación de roller y las máquinas de café. Además, te ofreceremos una variedad de actividades y misiones que deberás resolver para ganar puntos."
					}
					percentage={"100%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						window.location.href = "/home2/tema2/subtema1/activityOne"
					}}
				></DialogBarNew>
			)}
		</>
	);
};
